import axios from 'axios';
import { notifySessionExpired } from '../utils/session-expired-handler';
import getMeCache from './get-me-cache';

const baseURL = process.env.REACT_APP_API_URL;
const axiosClient = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/json',
        // Đánh dấu request đến từ web (không áp X2 cashback / voucher app-only)
        'X-Client': 'web',
        // Attribution headers cho ClickLog
        'X-App-Version': process.env.REACT_APP_VERSION || 'web',
        'X-OS': 'web',
    },
});

axiosClient.interceptors.request.use(function (config) {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers = {
            ...config.headers,
            Authorization: 'Bearer ' + token,
        };
    }
    return config;
});

// Endpoint xác thực bằng email/mật khẩu: 401 ở đây nghĩa là SAI THÔNG TIN ĐĂNG NHẬP
// của form đang mở, không phải phiên hiện tại hỏng -> không xoá token, không redirect.
const CREDENTIAL_ENDPOINTS = ['user/login', 'user/auth/google', 'user/auth/apple'];
const isCredentialEndpoint = (url) =>
    !!url && CREDENTIAL_ENDPOINTS.some((path) => url.includes(path));

// Response interceptor: chỉ đăng xuất khi 401 = phiên hỏng thật (thiếu/sai/hết hạn
// token). Lỗi nghiệp vụ (OTP sai, thiếu quyền) backend trả 400/403 nên không vào đây
// — trước đây các lỗi đó trả 401 khiến user đang thao tác bị đá về trang đăng nhập.
axiosClient.interceptors.response.use(
    (response) => {
        // Token sắp hết hạn → backend ký token mới kèm header X-Renewed-Token
        // (backend/src/utils/should-renew-token.js). Lưu đè để người đang dùng web
        // không bị đá về trang đăng nhập đúng ngày token cũ hết hạn.
        const renewed = response.headers?.['x-renewed-token'];
        if (typeof renewed === 'string' && renewed.split('.').length === 3) {
            localStorage.setItem('access_token', renewed);
        }
        // Vừa GHI dữ liệu lên server (rút tiền, đổi voucher, đọc thông báo...) ⇒ hồ sơ
        // đang cache chắc chắn cũ. Vứt ở đây một lần cho mọi trang, khỏi phải nhớ
        // truyền force ở từng chỗ.
        if ((response.config?.method || 'get').toLowerCase() !== 'get') getMeCache.reset();
        return response;
    },
    (error) => {
        if (
            error.response &&
            error.response.status === 401 &&
            !isCredentialEndpoint(error.config?.url)
        ) {
            // Xóa token và user info
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_info');
            // Không để hồ sơ của phiên vừa hỏng rơi sang lần đăng nhập kế tiếp.
            getMeCache.reset();

            // Điều hướng MỀM qua router (App đăng ký handler) thay vì
            // window.location.href — không reload app, không mất form đang nhập.
            if (window.location.pathname !== '/login') {
                notifySessionExpired();
            }
        }
        return Promise.reject(error);
    }
);

export default axiosClient;
